const server = process.env.REACT_APP_SERVER_URL || "";

export const commentLocationApi = {
  getTopOwners: async () => {
    const response = await fetch(`${server}/api/comment/top`);
    return response.json();
  },

  getRecentComments: async () => {
    const response = await fetch(`${server}/api/comment/recent`);
    return response.json();
  },
};
